import type { SVGProps } from 'react';
const SvgLocationDotSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.025 22.573c1.909-2.389 6.262-8.178 6.262-11.43C20.287 7.2 17.087 4 13.144 4A7.145 7.145 0 0 0 6 11.143c0 3.252 4.353 9.042 6.262 11.43.457.57 1.306.57 1.763 0m-.882-13.81a2.381 2.381 0 1 1 0 4.762 2.381 2.381 0 0 1 0-4.763"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLocationDotSolid;
